import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString } from "vue"




export default /*#__PURE__*/_defineComponent({
  __name: 'TextFormatter',
  props: {
    value: null
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.value.split('\n\n'), (paragraph, index) => {
    return (_openBlock(), _createElementBlock("p", { key: index }, _toDisplayString(paragraph), 1))
  }), 128))
}
}

})